module.exports = __webpack_public_path__ + "static/hello-6024c9bfe77a466cf26f7a11939e2bd2.svg";